import formatDistance from "date-fns/formatDistance";
import { particleListItem } from "./templates";
import insertNodeAfter from "../../utils/insertNodeAfter";
import { URL_CHANGE_EVENT } from "../../consts";
import { REFRESH_PARTICLE_LIST_TIME } from "./consts";

function particleListContainerContext(callback) {
    const listContainer = document.querySelector(".live-updates-list");
    if (listContainer) {
        callback(listContainer);
    }
}

const formatOpts = {
    includeSeconds: true,
    addSuffix: true,
};

function createListParticle(particle, headline, publishedAt) {
    const listItem = particleListItem.getElement();
    const titleContainer = listItem.querySelector(".particle-title");
    const dateContainer = listItem.querySelector(".particle-date");

    listItem.setAttribute("data-href", particle.dataset.href);
    listItem.querySelector("a").addEventListener("click", (event) => {
        event.preventDefault();
        particle.scrollIntoView(true);
    });

    titleContainer.innerText = headline;
    if (publishedAt) {
        dateContainer.innerText = formatDistance(publishedAt, new Date(), formatOpts);
    }

    return listItem;
}

const timestampToDate = (timestamp) => new Date(timestamp);

function clearList() {
    particleListContainerContext((listContainer) => {
        while (listContainer.firstChild) {
            listContainer.removeChild(listContainer.lastChild);
        }
    });
}

function renderList(container) {
    particleListContainerContext((listContainer) => {
        const listFragment = document.createDocumentFragment();
        const particleList = container.querySelectorAll("[data-id]");

        particleList.forEach((particle) => {
            const headline = particle.querySelector('[data-role="headline"]');
            const { publishedAt } = particle.dataset;
            const publishedAtDate = publishedAt
                ? timestampToDate(parseInt(publishedAt) * 1000)
                : null;

            if (headline) {
                listFragment.appendChild(
                    createListParticle(particle, headline.innerText, publishedAtDate)
                );
            }
        });
        listContainer.appendChild(listFragment);
    });
}

function activeParticleListener(eventBus) {
    particleListContainerContext((listContainer) => {
        eventBus.subscribe(URL_CHANGE_EVENT, () => {
            const newActive = listContainer.querySelector(`[data-href="${location.href}"]`);
            if (newActive) {
                listContainer
                    .querySelectorAll(".active")
                    .forEach((el) => el.classList.remove("active"));
                newActive.classList.add("active");
            }
        });
    });
}

export function renderAssemblerParticleList(container, eventBus) {
    activeParticleListener(eventBus);
    renderList(container);

    setInterval(() => {
        clearList();
        renderList(container);
    }, REFRESH_PARTICLE_LIST_TIME);
}

export function updateAssemblerParticleList(particle, data) {
    const { headline, publishedAt } = data;
    particleListContainerContext((listContainer) => {
        if (headline) {
            const date = isNaN(publishedAt) ? `${publishedAt}Z` : publishedAt;

            const listItem = createListParticle(particle, headline, timestampToDate(date));
            insertNodeAfter(listContainer.firstElementChild, listItem);
        }
    });
}
